import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import useShopTools from '../hooks/useShopTools';

/**
 * ToolGate — wraps a route so it renders `children` only when the given
 * tool is enabled. Otherwise redirects to `/dashboard` with a toast so
 * the owner understands why the page they clicked isn't accessible.
 *
 * Usage:
 *   <ToolGate tool="cassa"><CassaPage /></ToolGate>
 */
export default function ToolGate({ tool, children, fallback = '/dashboard' }) {
  const navigate = useNavigate();
  const { tools, loading, isEnabled } = useShopTools();

  const enabled = isEnabled(tool);

  useEffect(() => {
    if (loading) return;
    if (!enabled) {
      toast.info(`Lo strumento "${tool}" è disattivato. Attivalo da "Aggiungi strumenti".`);
      navigate(fallback, { replace: true });
    }
  }, [enabled, loading, tool, fallback, navigate, tools]);

  if (loading || !enabled) return null;
  return children;
}
